import React from 'react';
import { Box, Typography, Link, useTheme } from '@mui/material';

const Footer = () => {
  const theme = useTheme();

  return (
    <Box 
      component="footer" 
      sx={{ 
        pt: 1.25,
        pb: 1.5,
        px: 0,
        borderTop: '1px solid', 
        borderColor: 'divider',
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: 'center',
        justifyContent: 'space-between',
        bgcolor: 'background.paper',
        position: 'sticky',
        bottom: 0,
        zIndex: 1000
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: { xs: 2, sm: 0 } }}>
        <img 
          src="https://cdn.jsdelivr.net/gh/ecappmakers/ecapps-static@ecapps-v8/ecapps/assets/top-pane-logo.svg" 
          alt="EC Apps Logo" 
          style={{ height: 32, marginRight: 16 }}
        />
        <Typography variant="body2" color="text.secondary">
          © {new Date().getFullYear()} EC App Makers. All rights reserved.
        </Typography>
      </Box>
      <Box>
        <Link href="https://ecapps.in" target="_blank" rel="noopener noreferrer" color="text.secondary" sx={{ textDecoration: 'none', '&:hover': { color: 'primary.main' }, fontWeight: 'medium' }}>
          Visit ecapps.in
        </Link>
      </Box>
    </Box>
  );
};

export default Footer;
